export default {
  averageRating: 'Average provider rating: {rating}',
  dishName: 'Dish Name',
  avgRating: 'Avg. Rating',
  ratingsCount: 'Ratings Count',
  noComments: 'No Comments',
  tooltip: 'Click dish name for comments.',
  nothingFound: 'No ratings yet',
  nothingFoundBody: 'Some will come as the time flies.',
  ratingBtnNothingOrdered: 'You can leave feedback only in case of having lunch from this provider.',
  ratingBtnAlreadyRated: 'You already have rated your lunch.',
  ratingBtnLunchNotHappenedYet: 'You can leave feedback only after lunch has been served.',
};
